import get from 'lodash/get';
import { useFormContext } from 'react-hook-form';
import type { GlobalError } from 'react-hook-form/dist/types/errors';
import type { RegisterOptions } from 'react-hook-form/dist/types/validator';

import type { CheckboxProps } from '@/components/Checkbox';
import { Checkbox } from '@/components/Checkbox';
import { InputErrorMessage } from '@/components/InputErrorMessage';
import { theme } from '@/theme';

interface InputFieldProps extends CheckboxProps {
  marginLeft?: boolean;
  name: string;
  registerOptions?: RegisterOptions;
}

export const CheckboxField = ({
  marginLeft = false,
  name,
  registerOptions,
  ...props
}: InputFieldProps) => {
  const { formState, register } = useFormContext();
  const error = get(formState.errors, name) as GlobalError;

  return (
    <>
      <Checkbox
        data-test-id='CheckboxFieldCheckbox'
        hasError={!!error}
        {...register(name, registerOptions)}
        name={name}
        {...props}
      />
      {marginLeft ? (
        <div style={{ marginLeft: theme.spacing(4) }}>
          <InputErrorMessage
            data-test-id='CheckboxFieldInputErrorMessage'
            error={error}
          />
        </div>
      ) : (
        <InputErrorMessage
          data-test-id='CheckboxFieldInputErrorMessage'
          error={error}
        />
      )}
    </>
  );
};
